export default __webpack_public_path__ + "6f18405b75a3988ceee3c1d411c28adb.png";